export default __webpack_public_path__ + "static/media/beneath-the-brine.9dc6e328.jpg";